import { AuthorityStockTransfer } from './Authority.StockTransfer';
import { AuthorityYardManagement } from './Authority.YardManagement';
import { AuthorityProfile } from './Authority.Profile';
import { AuthorityAccessory } from './Authority.Accessory';
import { AuthorityAccountPayable } from './Authority.AccountPayable';
import { AuthorityAccountReceivable } from './Authority.AccountReceivable';
import { AuthorityArea } from './Authority.Area';
import { AuthorityBank } from './Authority.Bank';
import { AuthorityBankingEntries } from './Authority.BankingEntries';
import { AuthorityBill } from './Authority.Bill';
import { AuthorityCRM } from './Authority.CRM';
import { AuthorityCompany } from './Authority.Company';
import { AuthorityConsumable } from './Authority.Consumable';
import { AuthorityCostCenter } from './Authority.CostCenter';
import { AuthorityCustomer } from './Authority.Customer';
import { AuthorityDashboard } from './Authority.Dashboard';
import { AuthorityDefault } from './Authority.Default';
import { AuthorityDocumentType } from './Authority.DocumentType';
import { AuthorityEmployee } from './Authority.Employee';
import { AuthorityGroup } from './Authority.Group';
import { AuthorityInformative } from './Authority.Informative';
import { AuthorityInsurer } from './Authority.Insurer';
import { AuthorityInventary } from './Authority.Inventary';
import { AuthorityKits } from './Authority.Kits';
import { AuthorityManufacter } from './Authority.Manufacter';
import { AuthorityMaterial } from './Authority.Material';
import { AuthorityMatrix } from './Authority.Matrix';
import { AuthorityNCM } from './Authority.NCM';
import { AuthorityNotification } from './Authority.Notification';
import { AuthorityPart } from './Authority.Part';
import { AuthorityPayment } from './Authority.Payment';
import { AuthorityPlanAccount } from './Authority.PlanAccount';
import { AuthorityPurchase } from './Authority.Purchase';
import { AuthorityQuotation } from './Authority.Quotation';
import { AuthorityReport } from './Authority.Report';
import { AuthoritySale } from './Authority.Sale';
import { AuthoritySupplier } from './Authority.Supplier';
import { AuthorityTask } from './Authority.Task';
import { AuthorityUser } from './Authority.User';
import { AuthorityWorkorder } from './Authority.Workorder';
import { AuthorityInvoice } from './Authority.invoice';
import { AuthorityShedule } from './Authority.Schedule';
import { AuthorityCashMovement } from './Authority.CashMovement';
import { AuthorityStockCorrection } from './Authority.StockCorrection';
import { AuthorityStone } from './Authority.Stone';
import { AuthorityFiscalCoupon } from './Authority.FiscalCoupon';
import { AuthorityBankConciliation } from './Authority.BankConciliation';
import { AuthorityManifestationRecipient } from './Authority.ManifestationRecipient';
import { AuthorityVision } from './Authority.Vision';
import { AuthorityEmployeeCommission } from './Authority.EmployeeComission';
import { AuthorityClientArea } from './Authority.ClientArea';
import { AuthorityCompanyAvailabilities } from './Authority.CompanyAvailabilities';
import { AuthorityResourceLimitationPeriods } from './Authority.ResourceLimitationPeriods';
import { AuthorityTef } from './Authority.Tef';
import { AuthoritySPED } from './Authority.SPED';
import { AuthorityBosch } from './Authority.Bosch';

const Authorities = {
  ...AuthorityProfile,
  ...AuthorityAccessory,
  ...AuthorityAccountPayable,
  ...AuthorityAccountReceivable,
  ...AuthorityArea,
  ...AuthorityBank,
  ...AuthorityBankingEntries,
  ...AuthorityCashMovement,
  ...AuthorityBill,
  ...AuthorityCompany,
  ...AuthorityConsumable,
  ...AuthorityCostCenter,
  ...AuthorityCRM,
  ...AuthorityCustomer,
  ...AuthorityDashboard,
  ...AuthorityDefault,
  ...AuthorityDocumentType,
  ...AuthorityEmployee,
  ...AuthorityGroup,
  ...AuthorityInformative,
  ...AuthorityInsurer,
  ...AuthorityInventary,
  ...AuthorityInvoice,
  ...AuthorityKits,
  ...AuthorityManufacter,
  ...AuthorityMaterial,
  ...AuthorityMatrix,
  ...AuthorityNCM,
  ...AuthorityNotification,
  ...AuthorityPart,
  ...AuthorityPayment,
  ...AuthorityPlanAccount,
  ...AuthorityPurchase,
  ...AuthorityQuotation,
  ...AuthorityReport,
  ...AuthoritySale,
  ...AuthorityShedule,
  ...AuthorityStockCorrection,
  ...AuthoritySupplier,
  ...AuthorityTask,
  ...AuthorityUser,
  ...AuthorityWorkorder,
  ...AuthorityStone,
  ...AuthorityFiscalCoupon,
  ...AuthorityManifestationRecipient,
  ...AuthorityBankConciliation,
  ...AuthorityVision,
  ...AuthorityYardManagement,
  ...AuthorityEmployeeCommission,
  ...AuthorityStockTransfer,
  ...AuthorityCompanyAvailabilities,
  ...AuthorityResourceLimitationPeriods,
  ...AuthorityTef,
  ...AuthoritySPED,
  ...AuthorityBosch,
};

export type AuthoritiesType =
  | AuthorityProfile
  | AuthorityAccessory
  | AuthorityAccountPayable
  | AuthorityAccountReceivable
  | AuthorityArea
  | AuthorityBank
  | AuthorityBankingEntries
  | AuthorityCashMovement
  | AuthorityBill
  | AuthorityCompany
  | AuthorityConsumable
  | AuthorityCostCenter
  | AuthorityCRM
  | AuthorityCustomer
  | AuthorityDashboard
  | AuthorityDefault
  | AuthorityDocumentType
  | AuthorityEmployee
  | AuthorityGroup
  | AuthorityInformative
  | AuthorityInsurer
  | AuthorityInventary
  | AuthorityInvoice
  | AuthorityKits
  | AuthorityManufacter
  | AuthorityMaterial
  | AuthorityMatrix
  | AuthorityNCM
  | AuthorityNotification
  | AuthorityPart
  | AuthorityPayment
  | AuthorityPlanAccount
  | AuthorityPurchase
  | AuthorityQuotation
  | AuthorityReport
  | AuthoritySale
  | AuthorityShedule
  | AuthorityStockCorrection
  | AuthoritySupplier
  | AuthorityTask
  | AuthorityUser
  | AuthorityWorkorder
  | AuthorityStone
  | AuthorityFiscalCoupon
  | AuthorityManifestationRecipient
  | AuthorityBankConciliation
  | AuthorityVision
  | AuthorityYardManagement
  | AuthorityEmployeeCommission
  | AuthorityClientArea
  | AuthorityStockTransfer
  | AuthorityCompanyAvailabilities
  | AuthorityResourceLimitationPeriods
  | AuthorityTef
  | AuthoritySPED
  | AuthorityBosch;

export default Authorities;
